import { z } from "zod";

import { AddressSchema, AddressSchemaDefaultValues } from "../common/address";
import { MemberFormSchema, MemberFormSchemaDefaultValues } from "./member.schema";

const errorMessages = {
  required: "Ce champ est requis",
  invalidEmail: "L'adresse email est invalide",
  invalidPhoneNumber: "Le numéro de téléphone est invalide",
};

const OrganizationFormSchema = z.object({
  name: z.string().refine((value) => value.length > 0, {
    message: errorMessages.required,
  }),
  slug: z.string().refine((value) => value.length > 0, {
    message: errorMessages.required,
  }),
  settings: z.record(z.any()).optional().nullable().default({}),
  owner: z.object({
    ...MemberFormSchema.shape,
    address: AddressSchema,
  }),
});

export const OrganizationFormSchemaDefaultValues = {
  name: "",
  slug: "",
  settings: {},
  owner: {
    ...MemberFormSchemaDefaultValues,
    address: AddressSchemaDefaultValues,
  },
};

export type OrganizationFormSchemaType = z.infer<typeof OrganizationFormSchema>;
export { OrganizationFormSchema };
